import { mapQuotaFieldToDisplayName } from '@/config/plans'
import type { ConsoleUser, PlatformUser } from '../../stores/auth'
import { isConsoleUser, isPlatformUser } from '../../stores/auth'
import { useAuthStore } from '../../stores/authStore'
import type { NumericQuotaValue, QuotaUsage } from '../../types/quota'
import { usersApi } from '../usersApi'

const extractQuotaFromUser = (
	user: ConsoleUser | PlatformUser,
	tenantId: string,
	organizationId?: string | null,
): QuotaUsage => {
	const quotas: QuotaUsage['quotas'] = {}

	let perTenantQuota: Record<string, number | undefined> | undefined

	if (isConsoleUser(user)) {
		let organization = user.organizations?.[0]
		if (organizationId && user.organizations) {
			const matchedOrg = user.organizations.find(org => org.id === organizationId)
			if (matchedOrg) {
				organization = matchedOrg
			}
		}
		perTenantQuota = organization?.subscription?.quota?.per_tenant_quota
	} else if (isPlatformUser(user)) {
		if (user.organizations && user.organizations.length > 0) {
			let targetOrg = user.organizations[0]
			if (organizationId) {
				const found = user.organizations.find(o => o.id === organizationId)
				if (found) {
					targetOrg = found
				}
			}

			perTenantQuota = targetOrg.subscription?.quota?.per_tenant_quota
		}
	}

	if (perTenantQuota) {
		for (const [field, limit] of Object.entries(perTenantQuota)) {
			if (typeof limit === 'number') {
				const quotaType = mapQuotaFieldToDisplayName(field)
				if (quotaType) {
					quotas[quotaType] = {
						used: 0,
						total: limit,
					} as NumericQuotaValue
				}
			}
		}
	}

	return {
		tenant_id: tenantId,
		quotas,
	}
}

export const quotaApi = {
	getQuotaUsage: async (tenantId: string): Promise<QuotaUsage> => {
		const user = await usersApi.getCurrentUser()
		const currentOrganizationId = useAuthStore.getState().currentOrganizationId
		return extractQuotaFromUser(user, tenantId, currentOrganizationId)
	},
}
